import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isEmpty, noop } from 'lodash';
import { Input, Modal, Radio } from 'antd';

import getUserId from 'shared/utils/getUserId';
import SectionSelector from 'shared/components/SectionSelector';
import { isSupervisorUser } from 'Auth/redux/auth.redux';

import s from './style/SectionModal.pcss';
import Loader from '../../../../shared/components/Loader/Loader';


@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class SectionModal extends React.Component {
  static propTypes = {
    section: PropTypes.shape(),
    items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    isSupervisor: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    section: {},
  };

  state = {
    name: this.props.section.id ? this.props.section.name : '',
    parentSection: this.props.section.id ? { id: this.props.section.parentSectionId } : {},
    isRoot: !this.props.isSupervisor,
    saving: false,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.visible && !nextProps.visible) {
      this.setState({ name: '', parentSection: {}, isRoot: !this.props.isSupervisor });
    } else {
      this.setState({
        name: nextProps.section.id ? nextProps.section.name : '',
        parentSection: { id: nextProps.section.parentSectionId },
        isRoot: !this.props.isSupervisor,
      });
    }
  }

  changeName = e => this.setState({ name: e.target.value });
  handleSectionTypeChange = () => this.setState({ isRoot: !this.state.isRoot });
  handleSectionSelect = parentSection => this.setState({ parentSection });

  handleSave = () => {
    const { section } = this.props;
    const { name, parentSection, isRoot } = this.state;
    const body = { name };
    if (section.id) {
      body.id = section.id;
    } else {
      body.createdByUserId = getUserId();
    }
    if (!isEmpty(parentSection) && !isRoot) {
      body.parentSectionId = parentSection.id;
    }
    this.setState({ saving: true }, () => {
      this.props.onEdit(body).then(() => this.setState({ saving: false }));
    });
  };

  renderTitle = () => {
    const { section } = this.props;
    const { name, isRoot, parentSection, saving } = this.state;
    const saveDisabled = !name || (!isRoot && isEmpty(parentSection)) || saving;
    const onClick = saveDisabled ? noop : this.handleSave;
    const title = section.id ? section.name : 'Новый раздел';
    return (
      <div className={s.title}>
        <div className={s.titleLabel}>{title}</div>
        {!saving && (
          <div className={s.controls}>
            <div
              className={`${s.cancelBtn} ${saveDisabled ? s.disabled : ''}`}
              onClick={this.props.onClose}
            >
              Отменить
            </div>
            <div
              className={`${s.addBtn} ${saveDisabled ? s.disabled : ''}`}
              onClick={onClick}
            >
              {section.id ? 'Редактировать' : 'Добавить'}
            </div>
          </div>
        )}
        {saving && (
          <div className={s.controls}>
            <Loader fullScreen={false} size={20} />
          </div>
        )}
      </div>
    );
  };

  render() {
    const { visible, section } = this.props;
    const { name, isRoot, parentSection } = this.state;
    return (
      <div>
        <Modal
          title={this.renderTitle()}
          footer={null}
          visible={visible}
          closable={false}
          destroyOnClose
          width={'650px'}
          bodyStyle={{
            height: '230px',
          }}
          getContainer={() => ReactDOM.findDOMNode(this)}
        >
          <div className={s.inputContainer}>
            <div className={s.inputLabel}>Название</div>
            <Input
              placeholder="Название..."
              value={name}
              onChange={this.changeName}
            />
          </div>
          {!section.id &&
            <Fragment>
              {!this.props.isSupervisor &&
                <div className={s.sectionTypeContainer}>
                  <Radio.Group value={isRoot} onChange={this.handleSectionTypeChange}>
                    <Radio value>Добавить дерево</Radio>
                    <Radio value={false}>Добавить раздел</Radio>
                  </Radio.Group>
                </div>
              }
              {!isRoot &&
                <SectionSelector
                  items={this.props.items}
                  section={parentSection}
                  onSelect={this.handleSectionSelect}
                />
              }
            </Fragment>
          }
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Sections/Sidebar/SectionModal.js